/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/userLists.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_ORG_LIST } from '../../api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};
export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    console.log(`getDraftApplicationsProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      if (client) {
        const res = await client.query(GET_ORG_LIST, {
          input: {
            limit: args?.size,
            skip: args?.offset,
            where: [],
            order: [
              {
                column: 'createdAt',
                direction: 'DESC',
              },
            ],
          },
        });
        console.log('ress->', res);
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(res?.data?.getListOfOrg?.data);
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            //userRoles: res?.data?.getRoleList?.data,
            isEmpty: res?.data?.getListOfOrg?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfOrg?.currentPage,
            pageSize: res?.data?.getListOfOrg?.pageSize,
            totalCount: res?.data?.getListOfOrg?.totalCount,
            totalPages: res?.data?.getListOfOrg?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.vuid,
          status:
            this.getFormattedStatus(item?.status, item?.suspended) ??
            'invited ',
          // status: this.getFormattedStatus(item?.accountStatus, item?.suspended) ?? "invited ",
          name: `${toHeaderCase(item?.name ?? '')}`,
          email: item?.email,
          dateInvited: this.formatCreatedDate(item?.createdAt) ?? '-',
          image: item?.image,
          verified: item?.emailVerified,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return 'suspended';
    } else {
      switch (status) {
        case 'ONBORADED':
          return 'onboarded';
        case 'APPROVAL_PENDING':
          return 'approval pending';
        case 'ACTIVE':
          return 'active';
        case 'USER_VERIFIED':
          return 'verified';
        case 'CLOSED':
          return 'closed';
        case 'WALLET_REGISTERED':
          return 'active';
        case 'SUSPENDED':
          return 'suspended';
        case 'INVITED':
          return 'invited';
        default:
          return '-';
      }
    }
  }
}
